export type PriorityTier = 'strategic' | 'recommended' | 'opportunistic';

export function priorityTier(p?: number | null): PriorityTier {
  const v = p ?? 0;
  if (v >= 10) return 'strategic';
  if (v >= 5) return 'recommended';
  return 'opportunistic';
}

export const PRIORITY_BG: Record<PriorityTier, string> = {
  strategic: '#FFE1AD',
  recommended: '#B5E2FF',
  opportunistic: '#EFEFEF',
};

export const PRIORITY_BORDER: Record<PriorityTier, string> = {
  strategic: '#FFE1AD',
  recommended: '#B5E2FF',
  opportunistic: '#EFEFEF',
};

export const PRIORITY_LEGEND_BG: Record<PriorityTier, string> = {
  strategic: '#FFE1AD',
  recommended: '#B5E2FF',
  opportunistic: '#E7E7E7',
};

/**
 * Foreground (text) color per tier — used by the editMode S/R/O label that
 * mimics the prototype's plain colored text (no chip background).
 */
export const PRIORITY_TEXT_COLOR: Record<PriorityTier, string> = {
  strategic: '#d97706',
  recommended: '#2563eb',
  opportunistic: '#64748b',
};

export const PRIORITY_LABEL: Record<PriorityTier, string> = {
  strategic: 'Strategic',
  recommended: 'Recommended',
  opportunistic: 'Opportunistic',
};

export const PRIORITY_BG_EDIT: Record<PriorityTier, string> = {
  strategic: 'rgba(255, 225, 173, 0.2)',
  recommended: 'rgba(181, 226, 255, 0.2)',
  opportunistic: 'rgba(231, 231, 231, 0.2)',
};

export const PRIORITY_HANDLE_COLOR: Record<PriorityTier, string> = {
  strategic: '#d97706',
  recommended: '#2563eb',
  opportunistic: '#9ca3af',
};
